import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { updateFeedback } from '../APIServices/GlobalService';
export interface IglobalState {
  loading: boolean;
  language: string;
}

const initialState: IglobalState = {
  loading: false,
  language: 'en',
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    activateLoading: (state) => {
      state.loading = true;
    },
    deactivateLoading: (state) => {
      state.loading = false;
    },
    changeLang: (state, action: PayloadAction<string>) => {
      state.language = action?.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { activateLoading, deactivateLoading, changeLang } = globalSlice.actions;
export default globalSlice.reducer;

export const submitFeedback = createAsyncThunk(
  'Global/submitFeedback',
  async (queryPayload: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await updateFeedback(queryPayload);
    dispatch(deactivateLoading());
    return response;
  },
);
